module.exports = __webpack_public_path__ + "img/e1.4af0215d.png";